/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import 'aisztheme';

import React from 'react';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';
import { injectIntl } from 'react-intl';
import SideBar from 'loracoms/SideBar';
import SidebarContainer from 'loracoms/SidebarContainer';
import IntlMsg from 'lorautils/intl/IntlMsg';
import {
  getDeviceDetail,
  getDataSize,
} from 'loraapi/lora_device';
import deviceActions from 'loraactions/device';
import appActions from 'loraactions/app';
import StatView from './coms/StatView';
import MacView from './coms/MacView';
import LRAPView from './coms/LRAPView';
import ADRView from './coms/ADRView';
import DataToolView from './coms/DataToolView';
import TopoView from './coms/TopoView';
import styles from './styles.scss';

const propTypes = {
  view: React.PropTypes.string.isRequired,
  intl: React.PropTypes.any.isRequired,
  getDevice: React.PropTypes.func.isRequired,
  deviceId: React.PropTypes.string.isRequired,
  appId: React.PropTypes.string.isRequired,
  children: React.PropTypes.node.isRequired,
  getApp: React.PropTypes.func.isRequired,
  pushState: React.PropTypes.func.isRequired,
};

const defaultProps = {};


class DeviceDetail extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      view: props.view,
      detail: {},
      showToken: false,
      devTypes: [],
      lwanvers: [],
    };

    this.refreshMac = this.refreshMac.bind(this);
    this.refreshDetail = this.refreshDetail.bind(this);
    this.intlMsg = new IntlMsg(props.intl, 'devicedetail');
  }

  componentWillMount() {
    const { getDevice, deviceId, getApp, appId } = this.props;
    getDevice(deviceId);
    getApp(appId);
  }

  componentDidMount() {
    this.refreshDetail();
  }

  componentWillReceiveProps(nextProps) {
    const { view } = nextProps;
    if (view !== this.props.view) {
      this.setState({ view });
    }
  }

  refreshDetail(cb) {
    const { deviceId } = this.props;
    getDeviceDetail(deviceId).then((res) => {
      this.setState({
        detail: res.body,
      });
      if (cb) {
        cb();
      }
    });
    getDataSize(deviceId).then((res) => {
      this.setState({
        size: res.body.size,
      });
    });
  }

  refreshMac(cb) {
    this.refreshDetail(cb);
    this.setState({
      view: 'mac',
    });
  }

  renderSideBar() {
    const { pushState, appId, deviceId } = this.props;
    const { view } = this.state;
    return (
      <SideBar
        height={window.innerHeight}
        title={this.intlMsg.msg('sidebar.title')}
        menuItems={[{
          icon: <span className="glyphicons glyphicons-blackboard" />,
          text: this.intlMsg.msg('sidebar.menu.detail'),
          onClick: () => pushState(`/application/${appId}/devices/${deviceId}`),
          active: view === 'detail',
        }, {
          icon: <span className="glyphicons glyphicons-pie-chart" />,
          text: this.intlMsg.msg('sidebar.menu.stat'),
          onClick: () => pushState(`/application/${appId}/devices/${deviceId}/stat`),
          active: view === 'stat',
        }, {
          icon: <span className="glyphicons glyphicons-transfer rotate270" />,
          text: this.intlMsg.msg('sidebar.menu.datatool'),
          onClick: () => pushState(`/application/${appId}/devices/${deviceId}/datatool`),
          active: view === 'datatool',
        }, {
          icon: <span className="glyphicons glyphicons-notes-2" />,
          text: this.intlMsg.msg('sidebar.menu.devicelog'),
          onClick: () => pushState(`/application/${appId}/devices/${deviceId}/logs`),
          active: view === 'logs',
        }, {
          icon: <span className="glyphicons glyphicons-arrow-down" />,
          text: this.intlMsg.msg('sidebar.menu.maccommand'),
          onClick: () => pushState(`/application/${appId}/devices/${deviceId}/mac`),
          active: view === 'mac',
        }, {
          icon: <i className="fa fa-microchip" aria-hidden="true" />,
          text: this.intlMsg.msg('sidebar.menu.lrap'),
          onClick: () => pushState(`/application/${appId}/devices/${deviceId}/lrap`),
          active: view === 'lrap',
        }, {
          icon: <span className="glyphicons glyphicons-voice" />,
          text: 'ADR',
          onClick: () => pushState(`/application/${appId}/devices/${deviceId}/adr`),
          active: view === 'adr',
        }, {
          icon: <span className="glyphicons glyphicons-vector-path-polygon" />,
          text: this.intlMsg.msg('sidebar.menu.topo'),
          onClick: () => pushState(`/application/${appId}/devices/${deviceId}/topo`),
          active: view === 'topo',
        }]}
      />
    );
  }

  renderView() {
    const { appId, deviceId } = this.props;
    const {
      detail,
      view,
      appName,
    } = this.state;

    if (view === 'stat') {
      return (
        <StatView
          detail={detail}
          appId={appId}
          appName={appName || appId}
          deviceId={deviceId}
        />
      );
    } else if (view === 'mac') {
      return (
        <MacView
          detail={detail}
          appId={appId}
          appName={appName || appId}
          deviceId={deviceId}
          refreshDetail={this.refreshMac}
        />
      );
    } else if (view === 'lrap') {
      return (
        <LRAPView
          detail={detail}
          appId={appId}
          appName={appName || appId}
          deviceId={deviceId}
          refreshDetail={this.refreshDetail}
        />
      );
    } else if (view === 'adr') {
      return (
        <ADRView
          appId={appId}
          appName={appName || appId}
          deviceId={deviceId}
        />
      );
    } else if (view === 'datatool') {
      return (
        <DataToolView
          appId={appId}
          appName={appName || appId}
          deviceId={deviceId}
        />
      );
    } else if (view === 'topo') {
      return (
        <TopoView
          appId={appId}
          appName={appName || appId}
          deviceId={deviceId}
        />
      );
    }
    return null;
  }

  render() {
    return (
      <div>
        {this.renderSideBar()}
        <SidebarContainer>
          <div className={styles.view}>
            {this.props.children}
          </div>
        </SidebarContainer>
      </div>
    );
  }
}

DeviceDetail.defaultProps = defaultProps;
DeviceDetail.propTypes = propTypes;

const mapStateToProps = (state, ownProps) => ({
  view: ownProps.location.pathname.split('/')[5] || 'detail',
  deviceId: ownProps.params.deviceId,
  appId: ownProps.params.appId,
});

const mapDispatchToProps = {
  pushState: routerActions.push,
  getDevice: deviceActions.getDevice,
  getApp: appActions.getApp,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(DeviceDetail));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/DeviceDetail/index.jsx